var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":_vm.type,"size":_vm.size,"disabled":_vm.isDisabled},on:{"click":_vm.handleClick}},[(!_vm.count)?_vm._t("default"):_c('span',[_vm._v(" "+_vm._s(_vm.description)+" "+_vm._s(_vm.count)+"秒 ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }